import { createSelector } from '@ngrx/store';

export const getProjectAndProjectModelsLoading = createSelector(
  state => state['project']?.loading,
  state => state['projectModel']?.loading,
  (isProjectLoading: boolean, isModelsLoading: boolean) => isProjectLoading || isModelsLoading
);
